export default function ClosedAccounts({ accounts, formatMoney, disabled, onRestore, onHistory }) {
  const closed = accounts.filter(account => account.archived);
  if (!closed.length) return null;
  return <section className="accounts-closed" aria-label="Cuentas cerradas">
    <h2>Cuentas cerradas</h2>
    <p>Para editar, eliminar o cambiar de cuenta sus movimientos, restaura primero la cuenta de origen. Restaurar conserva el historial y los saldos del cierre.</p>
    <div className="accounts-grid">{closed.map(account => <article className="account-card" key={account.id}>
      <h3>{account.name} · {account.currency}</h3>
      <p>Cuenta cerrada · saldo registrado: {formatMoney(account.balance, account.currency)}</p>
      <button className="account-history-button" onClick={() => onHistory(account)}>Ver historial</button>
      <button className="account-add-movement" disabled={disabled || Boolean(account.closing_token)} onClick={() => onRestore(account)}>Restaurar {account.name}</button>
    </article>)}</div>
  </section>;
}
